const images = {
  howToScanGuideImage: require('./regiless_user_onboarding_01_2x.png'),
  chooseMenuGuideImage: require('./regiless_user_onboarding_02_2x.png'),
  foodServingGuideImage: require('./regiless_user_onboarding_03_2x.png'),
};
export default images;
